'use client';

import classnames from 'classnames';
import React from 'react';

import { useIsMounted } from '@cineamo/ui/src/hooks/useIsMounted';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

export type ListLoadingSpinnerProps = {
    className?: string;
    dotClass?: string;
};

export default function ListLoadingSpinner(props: ListLoadingSpinnerProps): React.JSX.Element {
    const { className, dotClass } = props;
    const domainConfiguration = useDomainConfiguration();
    const mounted = useIsMounted();

    if (!mounted) {
        return null;
    }

    return (
        <div className={classnames(className || 'py-38', 'w-full justify-center flex')}>
            <div className="flex space-x-8 items-center">
                <div className="flex h-28 items-center animate-bounce">
                    <div
                        className={classnames(dotClass || 'bg-cyan', 'h-6 w-6 rounded-full')}
                        style={
                            domainConfiguration
                                ? {
                                      backgroundColor: domainConfiguration.style.primaryColor
                                  }
                                : undefined
                        }
                    />
                </div>
                <div className="flex h-28 items-center animate-bounce200">
                    <div
                        className={classnames(dotClass || 'bg-cyan', 'h-6 w-6 rounded-full')}
                        style={
                            domainConfiguration
                                ? {
                                      backgroundColor: domainConfiguration.style.primaryColor
                                  }
                                : undefined
                        }
                    />
                </div>
                <div className="flex h-28 items-center animate-bounce400">
                    <div
                        className={classnames(dotClass || 'bg-cyan', 'h-6 w-6 rounded-full')}
                        style={
                            domainConfiguration
                                ? {
                                      backgroundColor: domainConfiguration.style.primaryColor
                                  }
                                : undefined
                        }
                    />
                </div>
            </div>
        </div>
    );
}
